import { render } from "./TodoCardUpdatePagamento.vue?vue&type=template&id=6924601a"
import script from "./TodoCardUpdatePagamento.vue?vue&type=script&lang=js"
export * from "./TodoCardUpdatePagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__